export default __webpack_public_path__ + "static/media/music.009ad5fe.jpg";